'use client';

import Header from '@/components/header';
import HeroResidential from '@/components/hero-residential';
import BrowseResidentialTypes from '@/components/browse-residential-types';
import FeaturedResidential from '@/components/featured-residential';
import PopularAreas from '@/components/popular-areas';
import WhyRent from '@/components/why-rent';
import RentalGuides from '@/components/rental-guides';
import CTAWhatsApp from '@/components/cta-whatsapp';
import Footer from '@/components/footer';

export default function ResidentialPage() {
  return (
    <main className="min-h-screen bg-background">
      <Header />
      <HeroResidential />
      <BrowseResidentialTypes />
      <FeaturedResidential />
      <PopularAreas />
      <WhyRent />
      <RentalGuides />
      <CTAWhatsApp />
      <Footer />
    </main>
  );
}
